// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectControlAlertCommandMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_CONTROL_ALERT_COMMAND_MESSAGE);
        this.AlertId = -1;
        this.AlertCommand = null;
    }
}
